module.exports = __webpack_public_path__ + "static/img/Architecture_大数据_image@2x.29d0c0c0.png";